import { render } from "./BankCardCarousel.vue?vue&type=template&id=f93ad512&scoped=true"
import script from "./BankCardCarousel.vue?vue&type=script&lang=js"
export * from "./BankCardCarousel.vue?vue&type=script&lang=js"

import "./BankCardCarousel.vue?vue&type=style&index=0&id=f93ad512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f93ad512"]])

export default __exports__